// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-27T17:09:28.759Z
// Property: Dobson Towne Centre (ID: 5686072616943616)
// Collections: 30 amenities, 4 floorplans (live), 29 photos, 40 POIs, 4 reviews, 3 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "5686072616943616",
  "property_external_id": "1125089",
  "property_zillow_url": "https://www.zillow.com/apartments/chandler-az-dobson-towne-centre-5XhyM5/",
  "property_apartments_url": "https://www.apartments.com/1817-n-dobson-rd-chandler-az/0ebnd51/",
  "property_google_business_url": "https://www.google.com/maps/place/Dobson+Towne+Centre/data=!4m2!3m1!1s0x0:0x1c1aebc9d5b62202?sa=X&ved=2ahUKEwiB25PuqriSAxXYZjABHYEyGf4Q_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "dobson-towne-centre",
  "property_name": "Dobson Towne Centre",
  "property_website_url": "https://www.dobsontownecentreapartments.com",
  "property_domain": "https://www.dobsontownecentreapartments.com",
  "property_address": "1817 North Dobson Road",
  "property_full_address": "1817 North Dobson Road, Chandler, AZ, 85224",
  "property_address_1": "1817 North Dobson Road",
  "property_address_2": null,
  "property_address_city": "Chandler",
  "property_address_state": "AZ",
  "property_address_zip_full": null,
  "property_address_zip": "85224",
  "property_address_country": "US",
  "property_address_county": "Maricopa County",
  "property_neighborhood_address": "North Chandler",
  "property_address_latitude": "33.3331",
  "property_address_longitude": "-111.8758",
  "property_email": "dobsontownecentre@weidner.com",
  "property_phone": "9283797502",
  "property_call_tracking_phone": "480-565-6462",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Dobson Towne Centre in Chandler, AZ, where comfort meets convenience. Choose from spacious one, two, or three-bedroom apartments featuring modern amenities like online payments, a built-in computer center, and optional detached garages. Pets are welcome! Find your new home today—browse our availability or schedule a tour!",
  "property_long_description": "**Welcome to Dobson Towne Centre—Your Ideal Apartment Community in Chandler, AZ!** \n\nDiscover your perfect living space at Dobson Towne Centre, where comfort meets convenience. Our community offers a variety of thoughtfully designed floor plans, including one, two, and three-bedroom apartments, ensuring there’s a home tailored for you. Each apartment features modern amenities designed to enhance your lifestyle, including oak cabinets, ceramic tile kitchens and baths, and in select homes, sleek stainless steel appliances and vinyl living areas.\n\nAt Dobson Towne Centre, we prioritize your comfort and convenience. Experience the ease of online rent payments and maintenance requests from the comfort of your home. Enjoy high-speed WiFi in common areas and take advantage of the built-in computer center with internet hookup in select apartments. \n\nWhether you’re looking for a family-friendly environment or a pet-friendly community, we’ve got you covered! Our smoke-free complex welcomes your furry friends and offers assigned covered parking and optional detached garages for added peace of mind. \n\nDon’t miss out on exclusive deals like one month of free high-speed internet courtesy of Cox Communications, and luxuriate in our Roman soaking tubs available in select homes. With mirrored closet doors and ceramic tile foyers, sophistication seamlessly blends with comfort.\n\nFind your new home today—explore our availability or schedule a tour to experience all that Dobson Towne Centre has to offer. Your dream apartment in Chandler, AZ awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-3e85-772f-90ad-02c86befc21b.webp",
  "property_featured_image_media": {
    "alt_text": "Sparkling outdoor swimming pool with lounge chairs and palm trees.",
    "public_id": "019d01a0-3e85-772f-90ad-02c86befc21b",
    "storage_key": "property/5686072616943616/019d01a0-3e85-772f-90ad-02c86befc21b.webp",
    "width": 1200,
    "height": 675
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "240",
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "350-450\n",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply, and pets must be under 50 lbs.",
  "property_pet_policy_description": "Cats and dogs are welcome (no weight limit). Up to 2 pets per home. One‑time pet fee: $200 per pet. Refundable pet deposit: $200 per pet. Monthly pet rent: $25 per pet. Breed restrictions apply for dogs; other small pets (hamsters, birds, turtles, fish) allowed with limits (e.g., max two birds, 20‑gal tank for tropical fish).",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://dobsontownecentreapartments.securecafe.com/onlineleasing/dobson-towne-centre-1/floorplans.aspx",
  "property_resident_portal_url": "https://dobsontownecentreapartments.securecafe.com/residentservices/dobson-towne-centre-1/userlogin.aspx",
  "property_apply_now_url": "https://dobsontownecentreapartments.securecafe.com/onlineleasing/dobson-towne-centre-1/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-004b-7395-9f88-d81d75dcc7cc.webp",
  "property_primary_logo_media": {
    "alt_text": "Dobson Towne Centre Apartments logo.",
    "public_id": "019d01a0-004b-7395-9f88-d81d75dcc7cc",
    "storage_key": "property/5686072616943616/019d01a0-004b-7395-9f88-d81d75dcc7cc.webp",
    "width": 1836,
    "height": 816
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-004b-7395-9f88-d81d75dcc7cc.webp",
  "property_secondary_logo_media": {
    "alt_text": "Dobson Towne Centre Apartments logo.",
    "public_id": "019d01a0-004b-7395-9f88-d81d75dcc7cc",
    "storage_key": "property/5686072616943616/019d01a0-004b-7395-9f88-d81d75dcc7cc.webp",
    "width": 1836,
    "height": 816
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a1-1d60-7589-a8df-5a496265100f.webp",
  "property_fav_icon_media": {
    "alt_text": "DTC logo",
    "public_id": "019d01a1-1d60-7589-a8df-5a496265100f",
    "storage_key": "property/5686072616943616/019d01a1-1d60-7589-a8df-5a496265100f.webp",
    "width": 900,
    "height": 816
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-2168-7133-88b7-47f3be17b4a5.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Dobson Towne Centre Apartments logo",
    "public_id": "019d01a0-2168-7133-88b7-47f3be17b4a5",
    "storage_key": "property/5686072616943616/019d01a0-2168-7133-88b7-47f3be17b4a5.webp",
    "width": 1836,
    "height": 816
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-004b-7395-9f88-d81d75dcc7cc.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Dobson Towne Centre Apartments logo.",
    "public_id": "019d01a0-004b-7395-9f88-d81d75dcc7cc",
    "storage_key": "property/5686072616943616/019d01a0-004b-7395-9f88-d81d75dcc7cc.webp",
    "width": 1836,
    "height": 816
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#f03029",
  "property_secondary_color": "#ecbc38",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#7a9da0",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "811 - 1102",
  "property_sqft_min": "811",
  "property_sqft_max": "1198",
  "property_price_range": "1425 - 2445",
  "property_price_min": "1320",
  "property_price_max": "3715",
  "property_available_units": 16,
  "property_facebook_url": "https://www.facebook.com/DobsonTowneCentreApartments",
  "property_instagram_url": "https://www.instagram.com/DobsonTCApts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJEynOimkHK4cRAiK21cnrGhw",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": "https://www.tiktok.com/discover/chinese-places-in-glendale-az",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Dobson Towne Centre",
  "property_home_romance_title": "Embrace Your Dream Home and Create Lasting Memories",
  "property_home_amenities_blurb": "At Dobson Towne Centre in Chandler, AZ, vibrant living meets ultimate convenience. Choose from spacious one, two, or three-bedroom floor plans designed for modern lifestyles. Enjoy exclusive amenities like refreshing pools, a state-of-the-art fitness center, and a smoke-free environment, all while having easy access to public transportation.",
  "property_home_floorplans_blurb": "At Dobson Towne Centre in Chandler, AZ, your ideal apartment awaits! Choose from spacious one, two, or three-bedroom floor plans designed for comfort and style. Whether you crave cozy evenings or vibrant gatherings, our community caters to all lifestyles. Browse now to uncover your perfect living space!",
  "property_home_gallery_blurb": "At Dobson Towne Centre in Chandler, AZ, your ideal home awaits. Choose from spacious one, two, or three-bedroom layouts, each featuring oversized patios and modern amenities. Enjoy 24-hour fitness access, refreshing pools, and on-site maintenance. Picture yourself living in a smoke-free, vibrant community designed for your lifestyle.",
  "property_home_neighborhood_blurb": "Discover vibrant living at Dobson Towne Centre in Chandler, AZ. Choose from spacious one, two, and three-bedroom floor plans designed for your lifestyle. See what’s around our community and explore local favorites and nearby points of interest. Embrace the perfect blend of comfort and convenience today!",
  "property_home_reviews_blurb": "At Dobson Towne Centre in Chandler, AZ, residents rave about the vibrant community atmosphere, with one noting, “The staff goes above and beyond to create a welcoming experience.” Dive into our reviews and see what makes living here truly special—your new home awaits!",
  "property_neighborhood_blurb": "At Dobson Towne Centre in Chandler, AZ, vibrant living meets endless possibilities. Nestled near top educational institutions and dynamic fitness centers like Sonoran University of Health Sciences and You Make CrossFit, our community connects you to a world of enriching experiences. See what's around our community and explore local favorites!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Discover the vibrant lifestyle at Dobson Towne Centre in Chandler, AZ, featuring spacious one, two, and three-bedroom apartments. Enjoy online payments, a smoke-free environment, and pet-friendly amenities. With options like stainless steel appliances and Roman soaking tubs, explore our amazing community amenities today! Your new home awaits!",
  "property_applynow_blurb": "Discover your new home at Dobson Towne Centre in Chandler, AZ! Choose from one, two, or three-bedroom floor plans featuring modern amenities like online payments, WiFi in common areas, and pet-friendly options. Enjoy spacious designs with stainless steel appliances and optional garages. Apply online today and experience luxury living!",
  "property_contactus_blurb": "Discover your perfect home at Dobson Towne Centre in Chandler, AZ! Our diverse floor plans include stylish one, two, and three-bedroom apartments to suit your lifestyle. Have questions? Our leasing team is ready to assist you—contact us today and find your ideal living space!",
  "property_faqs_blurb": "Discover your ideal home at Dobson Towne Centre in Chandler, AZ! Choose from our thoughtfully designed one, two, or three-bedroom floor plans. Have questions? Browse our FAQs page to find answers about our vibrant community and amenities today! Your perfect living experience awaits at Dobson Towne Centre!",
  "property_floorplans_blurb": "Discover your ideal living space at Dobson Towne Centre in Chandler, AZ. Our thoughtfully designed floor plans include stylish one, two, and three-bedroom apartments. Browse our available apartment homes today and find the perfect fit for your lifestyle. Embrace comfort and convenience in your new home!",
  "property_gallery_blurb": "Experience the vibrant lifestyle at Dobson Towne Centre in Chandler, AZ! Choose from spacious one, two, or three-bedroom floor plans, and enjoy fantastic amenities including online payments, pet-friendly policies, and high-speed internet. Picture yourself living here and explore our stunning photo gallery today!",
  "property_interactivemap_blurb": "Discover your perfect home at Dobson Towne Centre in Chandler, AZ! With spacious one, two, and three-bedroom floor plans, modern amenities, and a smoke-free environment, our community has it all. Enjoy online services, pet-friendly living, and a complimentary month of high-speed internet. Explore our interactive community map today!",
  "property_pets_blurb": "Welcome to Dobson Towne Centre in Chandler, AZ, where modern comforts meet vibrant community living. Enjoy spacious apartments filled with natural light, lush green spaces, and convenient access to shopping and dining. With a pet-friendly policy, your furry friends can thrive here too, making it the perfect place to call home!",
  "property_referafriend_blurb": "Welcome to Dobson Towne Centre in Chandler, AZ, where vibrant living meets comfort! Explore our diverse floor plans, including one, two, and three-bedroom apartments tailored to fit your lifestyle. Great friends make great neighbors—refer a friend to our community today and enjoy the benefits of living in harmony!",
  "property_residentaccess_blurb": "Welcome to Dobson Towne Centre in Chandler, AZ! Explore our spacious one, two, and three-bedroom floor plans, perfect for your lifestyle. Need assistance? Access your resident portal now to pay rent, schedule maintenance, and more. Elevate your living experience today!",
  "property_reviews_blurb": "At Dobson Towne Centre in Chandler, AZ, residents rave about their experience: “The sense of community here is unmatched!” Check out our reviews page to see firsthand how our vibrant atmosphere and welcoming neighbors make this apartment community feel like home. Join us today and be part of the buzz!",
  "property_created_at": "1747777287602",
  "property_scheduletour_blurb": "Discover your perfect home at Dobson Towne Centre in Chandler, AZ! We offer thoughtfully designed one, two, and three-bedroom floor plans to suit your lifestyle. Schedule a tour today and see what our residents love about living in our vibrant community. Your ideal apartment awaits—explore all options now!",
  "property_thankyou_blurb": "Thank you for your interest in Dobson Towne Centre in Chandler, AZ! Explore our diverse floor plans, featuring one-, two-, and three-bedroom apartments designed for your comfort. A team member will contact you shortly to assist you in finding your perfect home. Stay tuned for more information!",
  "property_virtualtours_blurb": "Discover your dream home at Dobson Towne Centre in Chandler, AZ! Explore our spacious one, two, and three-bedroom floor plans designed for your lifestyle. Take a virtual tour of our vibrant community and find the perfect apartment for rent today! Experience comfort and convenience like never before!",
  "property_copyright": "2025 All Rights Reserved. Dobson Towne Centre",
  "property_seo_title_home": "Dobson Towne Centre | Apartments in Chandler, AZ",
  "property_seo_description_home": "Discover your dream apartment at Dobson Towne Centre in Chandler, AZ! Choose from our spacious one, two, and three-bedroom floor plans designed with modern amenities including WiFi in common areas, online payments, and a smoke-free environment. Enjoy alluring features like ceramic tile in select homes, stainless steel appliances, and luxurious Roman soaking tubs. Plus, pets are welcome! Take advantage of assigned covered parking and get a month of free high-speed internet. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Chandler, AZ",
  "property_seo_description_floorplans": "Discover your ideal living space at Dobson Towne Centre in Chandler, AZ! Explore our diverse floor plans, including one, two, and three-bedroom apartments designed for comfort and style. Browse our available apartment homes today and find the perfect fit for your lifestyle!",
  "property_seo_title_amenities": "Amenities | Chandler, AZ Apartments for Rent",
  "property_seo_description_amenities": "Discover your perfect home at Dobson Towne Centre in Chandler, AZ! Our stunning one, two, and three-bedroom floor plans offer modern living with exceptional amenities. Enjoy perks like online payments, WiFi in common areas, and a smoke-free environment. With pet-friendly options, luxurious touches like Roman soaking tubs, and assigned covered parking, you’ll love coming home. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Chandler, AZ",
  "property_seo_description_gallery": "Discover the vibrant lifestyle at Dobson Towne Centre in Chandler, AZ! Explore our stunning photo gallery showcasing spacious one, two, and three-bedroom floor plans, complete with premium amenities like online payments, a built-in computer center, and pet-friendly options. Enjoy comfort with features such as ceramic tile kitchens and baths, Roman soaking tubs, and assigned covered parking. Imagine the convenience of a smoke-free community with Wi-Fi in common areas and a month of free high-speed internet courtesy of Cox Communications. Picture yourself living here—explore now!",
  "property_seo_title_virtualtours": "Virtual Tours | Dobson Towne Centre Apartments",
  "property_seo_description_virtualtours": "Explore Dobson Towne Centre in Chandler, AZ! Discover our spacious one, two, and three-bedroom floor plans tailored to your lifestyle. Take a virtual tour of our beautiful community and see your future home today! Don't miss out—schedule your tour now!",
  "property_seo_title_interactivemap": "Interactive Map | Dobson Towne Centre Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Dobson Towne Centre in Chandler, AZ! Explore our spacious one, two, and three-bedroom apartments featuring modern amenities like online payments, pet-friendly policies, and smoke-free living. Enjoy high-speed internet for a month on us, along with stylish upgrades like stainless steel appliances and Roman soaking tubs in select homes. Use our interactive community map to browse available apartments and pricing, and take the first step towards comfortable living today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Chandler, AZ",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Dobson Towne Centre in Chandler, AZ! From charming local favorites to nearby attractions, explore what makes our community special. Whether you’re interested in a cozy one-bedroom, a spacious two-bedroom, or a luxurious three-bedroom apartment, there’s something for everyone. See what's around and dive into the lifestyle that awaits you!",
  "property_seo_title_contact": "Contact Us | Dobson Towne Centre",
  "property_seo_description_contact": "Discover your perfect home at Dobson Towne Centre in Chandler, AZ! Explore our diverse floor plans, including one, two, and three-bedroom layouts designed for comfort and style. Have questions? Contact our leasing team today to learn more about our vibrant community and find your ideal apartment!",
  "property_seo_title_faqs": "FAQs | Apartments in Chandler, AZ",
  "property_seo_description_faqs": "Discover your perfect home at Dobson Towne Centre in Chandler, AZ! Our community offers spacious one, two, and three-bedroom floor plans with modern amenities like online payments, pet-friendly policies, and smoke-free living. Enjoy high-speed internet, a built-in computer center, and private garages—all designed for your convenience. Have questions? Browse our FAQs page to find answers and learn more about our vibrant community and exceptional living experience!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Chandler, AZ",
  "property_seo_description_reviews": "Discover the charm of Dobson Towne Centre in Chandler, AZ! With spacious one, two, and three-bedroom floor plans, our smoke-free community offers modern amenities like online payments, WiFi in common areas, and a built-in computer center. Enjoy the comfort of stainless steel appliances, ceramic tile kitchens, and the option for a detached garage. Plus, we’re pet-friendly and provide one month of free high-speed internet! Curious about resident experiences? See what our residents have to say about living at our vibrant community!",
  "property_seo_title_applynow": "Apply Now | Apartments in Chandler, AZ",
  "property_seo_description_applynow": "Discover your perfect home at Dobson Towne Centre in Chandler, AZ! Our community offers spacious one, two, and three-bedroom floor plans designed for modern living. Enjoy top-notch amenities like online payments, a pet-friendly environment, smoke-free living, and high-speed internet. Explore stylish features such as stainless steel appliances, ceramic tile accents, and optional detached garages. Don’t miss the chance for 1 month of free internet courtesy of Cox! Find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Dobson Towne Centre",
  "property_seo_description_residentaccess": "\"Welcome to Dobson Towne Centre in Chandler, AZ! Access your resident portal to effortlessly pay rent, schedule maintenance, and manage your apartment needs. Join our thriving community today!\"",
  "property_seo_title_referafriend": "Refer A Friend | Dobson Towne Centre",
  "property_seo_description_referafriend": "\"Great friends make great neighbors! Refer a friend to Dobson Towne Centre in Chandler, AZ, and enjoy exclusive rewards for bringing your besties to our vibrant apartment community. Share the joy of upscale living and community fun—refer today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Dobson Towne Centre",
  "property_seo_description_scheduletour": "\"Discover your new home at Dobson Towne Centre in Chandler, AZ! Experience vibrant living with modern amenities and a welcoming community. Schedule a tour today and take the first step toward your dream apartment!\"",
  "property_seo_title_privacy": "Privacy Policy | Dobson Towne Centre",
  "property_seo_description_privacy": "Explore how Dobson Towne Centre in Chandler, AZ, safeguards your personal information. Our privacy policy outlines our commitment to your data security and transparency. Click to view our privacy policy and learn more!",
  "property_seo_title_accessibility": "Website Accessibility | Dobson Towne Centre",
  "property_seo_description_accessibility": "Discover Dobson Towne Centre in Chandler, AZ, where we prioritize accessibility for all residents. Our commitment to digital inclusion ensures that everyone can enjoy a seamless online experience. Explore our accessibility statement to learn how we strive to create an inclusive community. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Dobson Towne Centre",
  "property_seo_description_sitemap": "\"Explore Dobson Towne Centre in Chandler, AZ—your ultimate destination for chic living! Navigate our comprehensive sitemap for easy access to community features, floor plans, and local attractions. Discover your perfect home today!\"",
  "property_seo_title_thankyou": "Thank You | Dobson Towne Centre",
  "property_seo_description_thankyou": "\"Thank you for your interest in Dobson Towne Centre in Chandler, AZ! Your submission has been received, and a member of our friendly team will reach out soon. Discover your ideal apartment community with top-notch amenities and exceptional service! Stay tuned!\"",
  "property_seo_title_pets": "Pet Policy | Apartments in Chandler, AZ",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293666572",
  "amenities": [
    {
      "id": "custom_0d9740df-7210-4a3b-9406-7846773e8ea7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Access Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_df0095fc-e079-43b9-b7a5-252591918946",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Business Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_53d96097-6385-47fc-932c-85882c2be36e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Two Refreshing Pools",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b864aee6-f827-4829-b0f8-0b0f14145a84",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Spas",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2ba92319-3a42-458e-b78d-6ee95c3f8b74",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Gas BBQ grills",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ba05a4bc-ea58-434b-8c47-7a715f31c807",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access Gates",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_61ae82f7-1ef4-48fe-94e5-5cf8c8bb10d3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0e2032a4-1860-42e5-aa6f-6c17eeb7d816",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "On Site Maintenance & Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_95669ef2-94c7-4f77-86cb-8ef40d359838",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Smoke‑Free Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_08921215-0f35-439b-8b90-a093f8337621",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Close to Public Transportation",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0726e245-5fdd-45b2-98f8-1a0fd26f2d65",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Assigned Covered Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3ffe7462-221f-48f2-bbe0-ab83b2ab734a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Optional Detached Garage with Remote Access",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_26eaa748-32c1-45d7-8c7c-53ba4f5408c1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Detached Garages Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0e8abf52-f799-45cf-9225-5ef174a950af",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "WiFi In Common Areas",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1c87ed32-9688-4279-92c2-f42b8941353e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Oversized Patios",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3db6dbf9-97a0-46bd-a5fb-49b25247a61e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Built‑In Computer Center with Internet Hookup*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e7fd536f-76c7-41db-835c-238f4f788ced",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Built in Microwave",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e26eb360-9851-4cdd-b8ff-8c36c1f6529b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_168b0452-b1e7-4e57-8cc5-57b5b5f6762b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Ceramic Tile Foyer in Select Homes",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0db66858-29e6-436e-b7c6-c6dae6ba0ec7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Ceramic Tile Kitchen and Baths",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8fca272a-e336-409b-b02a-c1f204d1ed68",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Full Size Washer and Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d4552808-a0d6-4dcf-9029-1a443453f462",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Oak Cabinets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_efc9b8f1-c5bf-479b-91d0-6d0748e4ddee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Roman Soaking Tub*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cf6ba132-a2e6-432c-bd67-ecebfa1589b6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Walk‑in Closet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_08218a64-71a8-43b2-8473-0c73cd9e7175",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Mirrored Closet Doors",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c1a8e94d-7250-48f2-a25b-cbae10689255",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "White‑on‑White GE Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_77d5d251-e6b0-4a6d-bffb-57e612923487",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "1 Month of Free High‑Speed Internet Courtesy of Cox Communications",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a85f6b9f-b169-4108-bdfc-2ab1c9a4a498",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl Living and Dining Rooms in Select Homes",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f99c1761-ea05-4500-9014-92624911cec0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Kitchen Appliances in Select Homes",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_54c17599-f494-471b-a3ab-c81b8b56b91c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "external_id": "false",
      "title": "Cox Quick Connect",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_5bfc63c3674d32e587e6be6d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-86f0-778c-b7fd-bdba2397c8eb.webp",
      "image_media": {
        "alt_text": "Living room with a view of the community pool.",
        "public_id": "019d019f-86f0-778c-b7fd-bdba2397c8eb",
        "storage_key": "property/5686072616943616/019d019f-86f0-778c-b7fd-bdba2397c8eb.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Community",
      "description": "Relax in this spacious living room with a beautiful view of the community pool and resort-style amenities.",
      "link": "false",
      "alt_text": "Living room with a view of the community pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (1).jpg"
    },
    {
      "id": "ec_cea37003124e8104ac1644b3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-8743-719e-95a5-4e4040e61c02.webp",
      "image_media": {
        "alt_text": "Living and dining area with a sofa, coffee table, and dining set, overlooking the pool.",
        "public_id": "019d019f-8743-719e-95a5-4e4040e61c02",
        "storage_key": "property/5686072616943616/019d019f-8743-719e-95a5-4e4040e61c02.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with comfortable seating and a dining set, offering views of the community pool.",
      "link": "false",
      "alt_text": "Living and dining area with a sofa, coffee table, and dining set, overlooking the pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (2).jpg"
    },
    {
      "id": "ec_7a1ba25f52566ba843c948da",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-882e-70d2-b6ef-2df6f62f6056.webp",
      "image_media": {
        "alt_text": "Dining area with a round table set for dinner, leading to a bedroom with a king-sized bed.",
        "public_id": "019d019f-882e-70d2-b6ef-2df6f62f6056",
        "storage_key": "property/5686072616943616/019d019f-882e-70d2-b6ef-2df6f62f6056.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy meals in the elegant dining area, featuring a round table with place settings. The adjoining bedroom offers a comfortable king-sized bed.",
      "link": "false",
      "alt_text": "Dining area with a round table set for dinner, leading to a bedroom with a king-sized bed.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (3).jpg"
    },
    {
      "id": "ec_27804e21782d95eb4ded49cf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-8f1a-76aa-ab5e-3e31c23b46fb.webp",
      "image_media": {
        "alt_text": "Living room with gray sofa, white armchair, coffee table, and window view of community.",
        "public_id": "019d019f-8f1a-76aa-ab5e-3e31c23b46fb",
        "storage_key": "property/5686072616943616/019d019f-8f1a-76aa-ab5e-3e31c23b46fb.webp",
        "width": 800,
        "height": 533
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a plush gray sofa, a stylish white armchair, and a modern coffee table, all complemented by warm lighting and a view of the community amenities.",
      "link": "false",
      "alt_text": "Living room with gray sofa, white armchair, coffee table, and window view of community.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (4).jpg"
    },
    {
      "id": "ec_d073a31a5e06617f4ea54ab9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-9442-72cd-8d0b-3018ec36e190.webp",
      "image_media": {
        "alt_text": "Living room and dining area with a view of the pool and a glimpse of the bedroom.",
        "public_id": "019d019f-9442-72cd-8d0b-3018ec36e190",
        "storage_key": "property/5686072616943616/019d019f-9442-72cd-8d0b-3018ec36e190.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with a beautiful view of the community pool. Enjoy comfortable living in this well-appointed apartment.",
      "link": "false",
      "alt_text": "Living room and dining area with a view of the pool and a glimpse of the bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (5).jpg"
    },
    {
      "id": "ec_450a73761715030a718c1a44",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-946d-710b-b5cf-0630726c833a.webp",
      "image_media": {
        "alt_text": "Kitchen and living area with desk and chair",
        "public_id": "019d019f-946d-710b-b5cf-0630726c833a",
        "storage_key": "property/5686072616943616/019d019f-946d-710b-b5cf-0630726c833a.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Spacious kitchen with ample cabinet space, connected to a bright living area featuring a desk and comfortable seating. Ideal for modern living.",
      "link": "false",
      "alt_text": "Kitchen and living area with desk and chair",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (6).jpg"
    },
    {
      "id": "ec_519cb7324c65ad5180347bc4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-9326-7124-8b06-3086b319ff19.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, white appliances, and granite countertops.",
        "public_id": "019d019f-9326-7124-8b06-3086b319ff19",
        "storage_key": "property/5686072616943616/019d019f-9326-7124-8b06-3086b319ff19.webp",
        "width": 2048,
        "height": 1257
      },
      "title": "Apartment",
      "description": "A modern kitchen featuring ample wood cabinetry, granite countertops, and a full suite of white appliances, perfect for any home chef.",
      "link": "false",
      "alt_text": "Kitchen with wood cabinets, white appliances, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (7).jpg"
    },
    {
      "id": "ec_92dbeff62ab7c1d332ed4d3f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-9800-771e-b78f-dff763fc10c1.webp",
      "image_media": {
        "alt_text": "Kitchen with white refrigerator, white oven, microwave, and wood cabinets.",
        "public_id": "019d019f-9800-771e-b78f-dff763fc10c1",
        "storage_key": "property/5686072616943616/019d019f-9800-771e-b78f-dff763fc10c1.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring stainless steel appliances, ample cabinet space, and granite countertops. Perfect for preparing meals.",
      "link": "false",
      "alt_text": "Kitchen with white refrigerator, white oven, microwave, and wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (8).jpg"
    },
    {
      "id": "ec_32b5c133f2c83675c8fa9cbf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-9fcf-747d-a3bf-432e79af94f5.webp",
      "image_media": {
        "alt_text": "Kitchen with white refrigerator, oven, microwave, wooden cabinets, and granite countertops.",
        "public_id": "019d019f-9fcf-747d-a3bf-432e79af94f5",
        "storage_key": "property/5686072616943616/019d019f-9fcf-747d-a3bf-432e79af94f5.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Explore this charming kitchen featuring a white refrigerator, oven, microwave, ample wooden cabinetry, and elegant granite countertops.",
      "link": "false",
      "alt_text": "Kitchen with white refrigerator, oven, microwave, wooden cabinets, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (9).jpg"
    },
    {
      "id": "ec_9d68d44da41efbec1fa5b624",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-9fe5-70a1-a301-af5d55280792.webp",
      "image_media": {
        "alt_text": "Bedroom with large bed, nightstand, closet, and vanity.",
        "public_id": "019d019f-9fe5-70a1-a301-af5d55280792",
        "storage_key": "property/5686072616943616/019d019f-9fe5-70a1-a301-af5d55280792.webp",
        "width": 1344,
        "height": 768
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large bed, convenient closet space, and a vanity area with a mirror and chair.",
      "link": "false",
      "alt_text": "Bedroom with large bed, nightstand, closet, and vanity.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (10).jpg"
    },
    {
      "id": "ec_88005b59cec3a4e8cee924ee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-a16d-71cc-86de-ec18ab958098.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, ceiling fan, and patio access.",
        "public_id": "019d019f-a16d-71cc-86de-ec18ab958098",
        "storage_key": "property/5686072616943616/019d019f-a16d-71cc-86de-ec18ab958098.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, a ceiling fan for comfort, and direct access to your private patio.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, ceiling fan, and patio access.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (11).jpg"
    },
    {
      "id": "ec_5414ffadee02d1af38ef0cc7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-a81c-748a-9a14-f5700db83c34.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, closet, and a large mirror.",
        "public_id": "019d019f-a81c-748a-9a14-f5700db83c34",
        "storage_key": "property/5686072616943616/019d019f-a81c-748a-9a14-f5700db83c34.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-sized bed, ample closet space, and elegant decor. A large mirror reflects the room's serene ambiance.",
      "link": "false",
      "alt_text": "Bedroom with a queen-sized bed, closet, and a large mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (12).jpg"
    },
    {
      "id": "ec_b483419445e620b6c43fdfaf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-a8b0-75d6-a3e0-46541c8b7405.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a king-size bed, nightstands, ceiling fan, closet, and vanity area.",
        "public_id": "019d019f-a8b0-75d6-a3e0-46541c8b7405",
        "storage_key": "property/5686072616943616/019d019f-a8b0-75d6-a3e0-46541c8b7405.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-size bed, ample closet space, and a convenient vanity area.",
      "link": "false",
      "alt_text": "Spacious bedroom with a king-size bed, nightstands, ceiling fan, closet, and vanity area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (13).jpg"
    },
    {
      "id": "ec_f76be20dde0ce1c6dd3a35ff",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-a8f1-779c-909e-33f70fabf4fb.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, toilet, and shower with striped curtain.",
        "public_id": "019d019f-a8f1-779c-909e-33f70fabf4fb",
        "storage_key": "property/5686072616943616/019d019f-a8f1-779c-909e-33f70fabf4fb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy the convenience and comfort of this well-appointed bathroom, featuring a spacious vanity, modern fixtures, and a relaxing shower.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink, toilet, and shower with striped curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (14).jpg"
    },
    {
      "id": "ec_21300704759bdd67a1754841",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-aff6-74f9-926d-d3bdb77af638.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and shower with decorative curtain.",
        "public_id": "019d019f-aff6-74f9-926d-d3bdb77af638",
        "storage_key": "property/5686072616943616/019d019f-aff6-74f9-926d-d3bdb77af638.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a large vanity with ample counter space, a bright vanity light, and a shower-tub combination with an attractive curtain.",
      "link": "false",
      "alt_text": "Bathroom with vanity, sink, toilet, and shower with decorative curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (15).jpg"
    },
    {
      "id": "ec_901e40fd5d031a5a884e891b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-b350-77d7-8d2a-685cc0c4871a.webp",
      "image_media": {
        "alt_text": "Patio dining set with orange umbrella, view into living room and bedroom.",
        "public_id": "019d019f-b350-77d7-8d2a-685cc0c4871a",
        "storage_key": "property/5686072616943616/019d019f-b350-77d7-8d2a-685cc0c4871a.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Enjoy outdoor dining on your private patio, perfect for relaxing and entertaining. This spacious balcony offers a comfortable seating area with a table and chairs, all shaded by a vibrant orange umbrella.",
      "link": "false",
      "alt_text": "Patio dining set with orange umbrella, view into living room and bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (16).jpg"
    },
    {
      "id": "ec_79872a13bd1ac061514cc4c2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-b600-71a0-8aee-863bb5fe0bf0.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with a water heater and laundry basket",
        "public_id": "019d019f-b600-71a0-8aee-863bb5fe0bf0",
        "storage_key": "property/5686072616943616/019d019f-b600-71a0-8aee-863bb5fe0bf0.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer, perfect for busy households. Includes a water heater and a laundry basket for all your needs.",
      "link": "false",
      "alt_text": "In-unit washer and dryer with a water heater and laundry basket",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (17).jpg"
    },
    {
      "id": "ec_b55aa7489fc7dad1f69b8c7d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-b4f8-7769-a459-b8a795e1e578.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and spa with lounge chairs and palm trees.",
        "public_id": "019d019f-b4f8-7769-a459-b8a795e1e578",
        "storage_key": "property/5686072616943616/019d019f-b4f8-7769-a459-b8a795e1e578.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool or relax in the adjacent spa. Lounge chairs and lush palm trees create a resort-like atmosphere for ultimate relaxation.",
      "link": "false",
      "alt_text": "Resort-style swimming pool and spa with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Arizona_Dobson-Twone-Center_Fitness-Center_Outside-3(2).jpg"
    },
    {
      "id": "ec_c802b36cb3e27011908d5607",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-baa8-72aa-b5e4-97074ac98156.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at an apartment complex.",
        "public_id": "019d019f-baa8-72aa-b5e4-97074ac98156",
        "storage_key": "property/5686072616943616/019d019f-baa8-72aa-b5e4-97074ac98156.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor pool, surrounded by lush palm trees and comfortable lounge chairs. Perfect for sunny afternoons.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at an apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Arizona_Dobson-Twone-Center_Fitness-Center_Outside-6(1).jpg"
    },
    {
      "id": "ec_0c683f46fcc959eb974c9fe9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-bdf0-767a-8c56-53542229b8ad.webp",
      "image_media": {
        "alt_text": "Hot tub in front of apartment buildings with outdoor seating",
        "public_id": "019d019f-bdf0-767a-8c56-53542229b8ad",
        "storage_key": "property/5686072616943616/019d019f-bdf0-767a-8c56-53542229b8ad.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a relaxing dip in the community hot tub, or unwind at the nearby outdoor seating area.",
      "link": "false",
      "alt_text": "Hot tub in front of apartment buildings with outdoor seating",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (20).jpg"
    },
    {
      "id": "ec_feccb75ed8a9f0e40f124089",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019e721c-53c4-725a-825e-07f8cde06af9.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, free weights, and weight machines.",
        "public_id": "019e721c-53c4-725a-825e-07f8cde06af9",
        "storage_key": "property/5686072616943616/019e721c-53c4-725a-825e-07f8cde06af9.webp",
        "width": 3034,
        "height": 1707
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines, free weights, and strength training equipment.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, ellipticals, free weights, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Arizona_Dobson-Twone-Center_Fitness-Center-1.jpg"
    },
    {
      "id": "ec_d1a49cb1aa39e6cfdd950675",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019e721c-543f-7632-9e09-6f90874142d7.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, stationary bikes, and weight machines.",
        "public_id": "019e721c-543f-7632-9e09-6f90874142d7",
        "storage_key": "property/5686072616943616/019e721c-543f-7632-9e09-6f90874142d7.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with cardio machines and weight training equipment to help you stay active and healthy.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, elliptical, stationary bikes, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Arizona_Dobson-Twone-Center_Fitness-Center-8(2).jpg"
    },
    {
      "id": "ec_eb2a4b71d5daa5238a9ee92b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-c363-7499-94b5-82d192f5ed25.webp",
      "image_media": {
        "alt_text": "Fitness center gym with treadmills, weight machines, and exercise balls.",
        "public_id": "019d019f-c363-7499-94b5-82d192f5ed25",
        "storage_key": "property/5686072616943616/019d019f-c363-7499-94b5-82d192f5ed25.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with cardio equipment, weight machines, free weights, and yoga mats. Open 24/7 for resident convenience.",
      "link": "false",
      "alt_text": "Fitness center gym with treadmills, weight machines, and exercise balls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Arizona_Dobson-Twone-Center_Fitness-Center-11(1).jpg"
    },
    {
      "id": "ec_d50a84752480626cb9ff4ddc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-c802-7101-aab1-34d207ca4ddf.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with chairs and a table overlooking the pool.",
        "public_id": "019d019f-c802-7101-aab1-34d207ca4ddf",
        "storage_key": "property/5686072616943616/019d019f-c802-7101-aab1-34d207ca4ddf.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax in our comfortable seating area while enjoying the view of the sparkling outdoor pool and lush landscaping.",
      "link": "false",
      "alt_text": "Comfortable seating area with chairs and a table overlooking the pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (24).jpg"
    },
    {
      "id": "ec_3ecf8b306a0693bfa9e3a2d9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-ca6f-7167-a331-6b93bf6d14c0.webp",
      "image_media": {
        "alt_text": "Living area with fireplace, built-in shelving, and comfortable seating.",
        "public_id": "019d019f-ca6f-7167-a331-6b93bf6d14c0",
        "storage_key": "property/5686072616943616/019d019f-ca6f-7167-a331-6b93bf6d14c0.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting living area, complete with a cozy fireplace and ample space for socializing.",
      "link": "false",
      "alt_text": "Living area with fireplace, built-in shelving, and comfortable seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (25).jpg"
    },
    {
      "id": "ec_ff87721ff3e1768a534e211e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-cef5-7738-b54a-cb8398cfa84c.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a table and chairs under an orange canopy, next to lounge chairs and a red umbrella.",
        "public_id": "019d019f-cef5-7738-b54a-cb8398cfa84c",
        "storage_key": "property/5686072616943616/019d019f-cef5-7738-b54a-cb8398cfa84c.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Community",
      "description": "Enjoy the outdoors with our comfortable seating area, perfect for relaxing by the pool. Features a table, chairs, lounge chairs, and a shaded canopy.",
      "link": "false",
      "alt_text": "Outdoor seating area with a table and chairs under an orange canopy, next to lounge chairs and a red umbrella.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (26).jpg"
    },
    {
      "id": "ec_b5c663b1d75cf131d3ba5e0b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-cdb2-72f9-af85-8213de879d99.webp",
      "image_media": {
        "alt_text": "Business center with computers, printer, and copier.",
        "public_id": "019d019f-cdb2-72f9-af85-8213de879d99",
        "storage_key": "property/5686072616943616/019d019f-cdb2-72f9-af85-8213de879d99.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Utilize the convenient business center, complete with computers, a printer, and a copier, to stay productive.",
      "link": "false",
      "alt_text": "Business center with computers, printer, and copier.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (27).jpg"
    },
    {
      "id": "ec_90507cdce6c6fad6d57a49de",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-d437-711d-aadf-e4139d5a12e3.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with palm trees and manicured lawn.",
        "public_id": "019d019f-d437-711d-aadf-e4139d5a12e3",
        "storage_key": "property/5686072616943616/019d019f-d437-711d-aadf-e4139d5a12e3.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Beautiful exterior view of the apartment complex, featuring lush green lawns, mature trees, and elegant architecture. Enjoy the resort-style living.",
      "link": "false",
      "alt_text": "Apartment building exterior with palm trees and manicured lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (28).jpg"
    },
    {
      "id": "ec_56a8e2ba65a597a662e72333",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d019f-d6d4-7422-ba0b-9aa7fddeb191.webp",
      "image_media": {
        "alt_text": "Dobson Towne Centre apartment homes monument sign with balloons",
        "public_id": "019d019f-d6d4-7422-ba0b-9aa7fddeb191",
        "storage_key": "property/5686072616943616/019d019f-d6d4-7422-ba0b-9aa7fddeb191.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to Dobson Towne Centre, offering apartment homes in a vibrant community. Discover your new home today!",
      "link": "false",
      "alt_text": "Dobson Towne Centre apartment homes monument sign with balloons",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Dobson-Towne-Center (29).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_bc587bee-9c2d-41d1-a29d-50828809f360",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Amici Pizza",
      "poi_type": "Restaurants",
      "poi_address": "2023 W Guadalupe Rd, Mesa, AZ 85202, USA",
      "poi_short_description": "Long-running counter-service joint offering New York-style slices, beer & wine in a modest setting.",
      "poi_long_description": "Diners say this pizza restaurant serves up delicious New York-style pizza, including the BBQ Chicken pizza and Vodka pizza, alongside tasty mozzarella sticks, fried ravioli, and wings. They also highlight the friendly and attentive staff, and the lively, family-friendly atmosphere.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-938d-73cf-b765-6304fb3bf705.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-938d-73cf-b765-6304fb3bf705",
        "storage_key": "property/5686072616943616/019d01a0-938d-73cf-b765-6304fb3bf705.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://amicipizzaaz.com/?y_source=1_MTI1NjY5MTEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6063598070706671147&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amici-pizza",
      "poi_latitude": "33.3629127",
      "poi_longitude": "-111.8774701",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 480-361-0006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-c952-775d-b633-30f7477c3534.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-c952-775d-b633-30f7477c3534",
        "storage_key": "property/5686072616943616/019d01a0-c952-775d-b633-30f7477c3534.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMeZPdJcHK4cRKw43qVE6JlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_3f7eccd9-66f9-4ac3-943e-053e0934637d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Jollibee",
      "poi_type": "Restaurants",
      "poi_address": "2800 E Germann Rd, Chandler, AZ 85286, USA",
      "poi_short_description": "Popular Philippines-based chain globally known for its famed fried chicken, spaghetti & burgers.",
      "poi_long_description": "People say this chicken restaurant serves crispy fried chicken, chicken sandwiches, and peach mango pies. They also highlight the fast service, friendly staff, and clean dining area.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-93ba-7350-a4ce-cbef596182d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-93ba-7350-a4ce-cbef596182d7",
        "storage_key": "property/5686072616943616/019d01a0-93ba-7350-a4ce-cbef596182d7.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://locations.jollibeefoods.com/usa/az/chandler/2800-e-germann-rd?utm_medium=organic&utm_source=local&utm_campaign=googlelistings&utm_content=website&utm_term=3052",
      "poi_directions_map_url": "https://maps.google.com/?cid=7953296695252312121&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jollibee",
      "poi_latitude": "33.2780952",
      "poi_longitude": "-111.7924112",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 480-561-0340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-c952-775d-b633-30f7477c3534.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-c952-775d-b633-30f7477c3534",
        "storage_key": "property/5686072616943616/019d01a0-c952-775d-b633-30f7477c3534.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-VhfJyyrK4cROWDNuTTJX24",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "custom_9c737805-e642-46f5-bbf0-3d5ac1774182",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Organ Stop Pizza",
      "poi_type": "Restaurants",
      "poi_address": "1149 E Southern Ave, Mesa, AZ 85204, USA",
      "poi_short_description": "Airy spot featuring a menu of pizza & Italian fare plus live music from a massive Wurlitzer organ.",
      "poi_long_description": "People say this pizza restaurant offers delicious pizza, a bountiful salad bar, and ice cream. They highlight the unique experience of watching a talented organist play a massive Wurlitzer organ, accompanied by instruments and puppets, and the fun, family-friendly atmosphere. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-93e9-77ec-999a-e5f73faf4546.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-93e9-77ec-999a-e5f73faf4546",
        "storage_key": "property/5686072616943616/019d01a0-93e9-77ec-999a-e5f73faf4546.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.organstoppizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4837900536302546487&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "organ-stop-pizza",
      "poi_latitude": "33.3929076",
      "poi_longitude": "-111.8077679",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 480-813-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-c952-775d-b633-30f7477c3534.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-c952-775d-b633-30f7477c3534",
        "storage_key": "property/5686072616943616/019d01a0-c952-775d-b633-30f7477c3534.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1GnlImoK4cRNy78zOesI0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_38e75d64-cdd4-476f-9a10-645d15b7ae36",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Rustler’s Rooste",
      "poi_type": "Restaurants",
      "poi_address": "8383 S 48th St, Phoenix, AZ 85044, USA",
      "poi_short_description": "Western-themed restaurant on a golf resort bringing together steaks, sweeping views & country bands.",
      "poi_long_description": "Diners say this American restaurant serves up delicious prime rib, cowboy platter, and rattlesnake, and they praise the generous portions and complimentary cotton candy. They also highlight the family-friendly atmosphere with live music, a slide, and city views.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-93eb-777a-8e59-b4a18f240801.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-93eb-777a-8e59-b4a18f240801",
        "storage_key": "property/5686072616943616/019d01a0-93eb-777a-8e59-b4a18f240801.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rustlersrooste.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1340500000724962898&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rustlers-rooste",
      "poi_latitude": "33.370324",
      "poi_longitude": "-111.973524",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 602-431-6474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-c952-775d-b633-30f7477c3534.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-c952-775d-b633-30f7477c3534",
        "storage_key": "property/5686072616943616/019d01a0-c952-775d-b633-30f7477c3534.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ46x3E_MFK4cRUk6f_KVpmhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_ca069086-30f6-464a-af34-60349f823ab3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "7050 W Ray Rd, Chandler, AZ 85226, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "Diners say this hamburger restaurant serves delicious cheeseburgers, fries, and shakes. They also highlight the friendly staff, fast service, and affordable prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-9810-7234-b826-e6a1f782ab05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-9810-7234-b826-e6a1f782ab05",
        "storage_key": "property/5686072616943616/019d01a0-9810-7234-b826-e6a1f782ab05.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.in-n-out.com/153",
      "poi_directions_map_url": "https://maps.google.com/?cid=5482242613931938438&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "33.3204081",
      "poi_longitude": "-111.9641262",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-c952-775d-b633-30f7477c3534.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-c952-775d-b633-30f7477c3534",
        "storage_key": "property/5686072616943616/019d01a0-c952-775d-b633-30f7477c3534.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ31gsqiQEK4cRhhLsd5zWFEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_e9b92be9-06b8-4a91-8053-322669308520",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Arizona Mills",
      "poi_type": "Shopping & Retail",
      "poi_address": "5000 S Arizona Mills Cir, Tempe, AZ 85282, USA",
      "poi_short_description": "Expansive indoor mall with 150+ retailers, restaurants & Arizona's largest IMAX theater.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including outlets, and entertainment options such as an aquarium, arcade, and movie theater. They also highlight the affordable prices, the fun and lively atmosphere, and the friendly staff.\n\nOther reviews mention the food court can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-9873-7374-9bcf-3117046aee6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-9873-7374-9bcf-3117046aee6d",
        "storage_key": "property/5686072616943616/019d01a0-9873-7374-9bcf-3117046aee6d.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.simon.com/mall/arizona-mills",
      "poi_directions_map_url": "https://maps.google.com/?cid=2145774981481083229&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arizona-mills",
      "poi_latitude": "33.383125",
      "poi_longitude": "-111.964485",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-491-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-c952-775d-b633-2c3257f11a99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-c952-775d-b633-2c3257f11a99",
        "storage_key": "property/5686072616943616/019d01a0-c952-775d-b633-2c3257f11a99.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJh_lm4VkPK4cRXbEZE_pSxx0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_3c280202-d93b-4dfa-86ec-0b39c3e37e7c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Chandler Fashion Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "3111 W Chandler Blvd, Chandler, AZ 85226, USA",
      "poi_short_description": "Indoor mall with higher-end & mainstream retailers, a movie theater, restaurants & a food court.",
      "poi_long_description": "People say this shopping center offers a wide variety of well-known stores and restaurants, as well as entertainment options like a movie theater, bowling, and arcades. They highlight the clean, modern, and well-maintained atmosphere, and the convenient parking. They also like the friendly and helpful staff in the stores.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-98c1-73cc-a948-1ed7033ed55f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-98c1-73cc-a948-1ed7033ed55f",
        "storage_key": "property/5686072616943616/019d01a0-98c1-73cc-a948-1ed7033ed55f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.shopchandlerfashioncenter.com/?utm_source=google&utm_medium=onlinesearch&utm_content=gmp_website_button&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=16948311328882979246&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chandler-fashion-center",
      "poi_latitude": "33.3014708",
      "poi_longitude": "-111.8984985",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 480-812-8488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-c952-775d-b633-2c3257f11a99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-c952-775d-b633-2c3257f11a99",
        "storage_key": "property/5686072616943616/019d01a0-c952-775d-b633-2c3257f11a99.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzevPCdQAK4cRrnHMjFt_NOs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_bd1a1961-2f83-4329-8010-771f9c517dd9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "IKEA",
      "poi_type": "Shopping & Retail",
      "poi_address": "2110 W Ikea Way, Tempe, AZ 85284, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "People say this furniture store offers a wide variety of affordable home goods, including furniture, plants, and Swedish meatballs. They also highlight the friendly and helpful staff, the clean and well-organized environment, and the fun and engaging shopping experience.\n\nSome reviews mention the delivery service can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-9973-7109-ad4d-033960f15afb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-9973-7109-ad4d-033960f15afb",
        "storage_key": "property/5686072616943616/019d01a0-9973-7109-ad4d-033960f15afb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/tempe/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=tempe",
      "poi_directions_map_url": "https://maps.google.com/?cid=15624796835480116642&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "33.3406452",
      "poi_longitude": "-111.9701824",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-c952-775d-b633-2c3257f11a99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-c952-775d-b633-2c3257f11a99",
        "storage_key": "property/5686072616943616/019d01a0-c952-775d-b633-2c3257f11a99.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJp2DFVMkFK4cRop1wKvBt1tg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_d2bfc631-039b-4eb2-890b-dd4eea666725",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "H Mart Mesa",
      "poi_type": "Shopping & Retail",
      "poi_address": "1919 W Main St, Mesa, AZ 85201, USA",
      "poi_short_description": "Asian grocery store chain supplying imported packaged foods & housewares plus ready-to-serve meals.",
      "poi_long_description": "Shoppers say this Asian grocery store offers a wide variety of fresh produce, seafood, and meats, as well as a great selection of snacks and ingredients for authentic Asian dishes. They also highlight the delicious food court with its diverse options, including Korean fried chicken and kimchi stew, and the clean and well-organized environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-9fcf-7008-b913-5f560a3bd82e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-9fcf-7008-b913-5f560a3bd82e",
        "storage_key": "property/5686072616943616/019d01a0-9fcf-7008-b913-5f560a3bd82e.webp",
        "width": 1104,
        "height": 621
      },
      "poi_business_url": "https://www.hmart.com/store/mesa-az-85201/f6d25951-7644-459c-addf-be97552f7808?has_food_court=true&message=",
      "poi_directions_map_url": "https://maps.google.com/?cid=485327551048822677&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-mart-mesa",
      "poi_latitude": "33.4134865",
      "poi_longitude": "-111.8729813",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-207-4560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-c952-775d-b633-280e30de3b96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-c952-775d-b633-280e30de3b96",
        "storage_key": "property/5686072616943616/019d01a0-c952-775d-b633-280e30de3b96.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc6ruLuEJK4cRla_5F9Y6vAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_80590291-04eb-41f8-87b0-c68184cf23d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2955 W Ray Rd, Chandler, AZ 85224, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, seafood, and prepared foods, including a hot bar, pizza, and bakery items. They also highlight the friendly and helpful staff, and the clean and well-maintained store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-9ff1-71a2-a2bc-0d9cbd4d3be3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-9ff1-71a2-a2bc-0d9cbd4d3be3",
        "storage_key": "property/5686072616943616/019d01a0-9ff1-71a2-a2bc-0d9cbd4d3be3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/chandler?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4756744573186128796&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "33.3183793",
      "poi_longitude": "-111.8927755",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 480-821-9447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-c952-775d-b633-280e30de3b96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-c952-775d-b633-280e30de3b96",
        "storage_key": "property/5686072616943616/019d01a0-c952-775d-b633-280e30de3b96.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0yLj2SQHK4cRnLsGrPxZA0I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b1352d7b-239f-4d50-a178-32a63bdcf743",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Mesa Community College",
      "poi_type": "Education",
      "poi_address": "1833 W Southern Ave, Mesa, AZ 85202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-a053-756c-8ceb-cbbbfd573990.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-a053-756c-8ceb-cbbbfd573990",
        "storage_key": "property/5686072616943616/019d01a0-a053-756c-8ceb-cbbbfd573990.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mesacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6768540005639575714&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mesa-community-college",
      "poi_latitude": "33.3895475",
      "poi_longitude": "-111.8735409",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-461-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-c953-745a-94ce-3e22ab511452.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-c953-745a-94ce-3e22ab511452",
        "storage_key": "property/5686072616943616/019d01a0-c953-745a-94ce-3e22ab511452.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJh1-MyeQHK4cRotgqHEav7l0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c03d95fc-234e-4f57-ba91-a3ecafeafcc8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Chandler Gilbert Community College - Pecos Campus",
      "poi_type": "Education",
      "poi_address": "2626 E Pecos Rd, Chandler, AZ 85225, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-a22d-752f-bfce-120eb4b20de9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-a22d-752f-bfce-120eb4b20de9",
        "storage_key": "property/5686072616943616/019d01a0-a22d-752f-bfce-120eb4b20de9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.cgc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9693566102967185172&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chandler-gilbert-community-college---pecos-campus",
      "poi_latitude": "33.2951034",
      "poi_longitude": "-111.7956814",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 480-732-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-c953-745a-94ce-3e22ab511452.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-c953-745a-94ce-3e22ab511452",
        "storage_key": "property/5686072616943616/019d01a0-c953-745a-94ce-3e22ab511452.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQUndrbqrK4cRFG8gDgN3hoY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_146b351e-1065-4b23-bf8d-061214ea5835",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Tempe Public Library",
      "poi_type": "Education",
      "poi_address": "3500 S Rural Rd, Tempe, AZ 85282, USA",
      "poi_short_description": "Public library offering books and media for checkout, plus a cafe and programs.",
      "poi_long_description": "People say this library offers a wide selection of books, media, and resources for all ages, including a convenient hold section and self-checkout kiosks. They highlight the rock-bottom prices on used books, the various events and activities, and the availability of meeting rooms and a cafe. They also like the friendly and helpful staff, and the presence of security guards.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-a485-713e-9685-61f6f6becf66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-a485-713e-9685-61f6f6becf66",
        "storage_key": "property/5686072616943616/019d01a0-a485-713e-9685-61f6f6becf66.webp",
        "width": 1280,
        "height": 951
      },
      "poi_business_url": "https://www.tempepubliclibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13306252390981778904&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tempe-public-library",
      "poi_latitude": "33.39131450000001",
      "poi_longitude": "-111.9280626",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 480-350-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-c953-745a-94ce-3e22ab511452.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-c953-745a-94ce-3e22ab511452",
        "storage_key": "property/5686072616943616/019d01a0-c953-745a-94ce-3e22ab511452.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR35tTZ8IK4cR2D0p0AxOqbg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_b7f30b07-45c3-4c24-be88-658dc3aed186",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Golfland Sunsplash",
      "poi_type": "Entertainment",
      "poi_address": "155 W Hampton Ave, Mesa, AZ 85210, USA",
      "poi_short_description": "Amusement chain outpost featuring mini golf & an arcade, plus waterslides & laser tag.",
      "poi_long_description": "People say this amusement park offers a variety of water slides, a wave pool, a lazy river, and a splash pad, as well as mini golf, go-karts, bumper boats, and an arcade. They also highlight the friendly and helpful staff, and the clean and well-maintained facilities.\n\nSome reviews mention the slides can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-a52c-7168-894b-cdc1ae702e70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-a52c-7168-894b-cdc1ae702e70",
        "storage_key": "property/5686072616943616/019d01a0-a52c-7168-894b-cdc1ae702e70.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.golfland.com/mesa",
      "poi_directions_map_url": "https://maps.google.com/?cid=7202226290688624874&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golfland-sunsplash",
      "poi_latitude": "33.3880994",
      "poi_longitude": "-111.8372277",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 480-834-8319",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-cce7-77d8-9fc0-a896f52fb778",
        "storage_key": "property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpZWRoxOoK4cR6oh5AKdy82M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_42cdb93a-909d-480d-a932-02930d4dc86d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "SEA LIFE Arizona Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "5000 S Arizona Mills Cir Suite 145, Tempe, AZ 85282, USA",
      "poi_short_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_long_description": "People say this aquarium offers a variety of sea creatures, including sharks, stingrays, and sea turtles, and features a 360-degree tunnel and interactive exhibits. They highlight the affordable prices, especially with combo tickets, and the fun, family-friendly atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-a62b-7059-839d-fa01f84a621c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-a62b-7059-839d-fa01f84a621c",
        "storage_key": "property/5686072616943616/019d01a0-a62b-7059-839d-fa01f84a621c.webp",
        "width": 960,
        "height": 639
      },
      "poi_business_url": "https://www.visitsealife.com/arizona/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=5764640459261859178&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sea-life-arizona-aquarium",
      "poi_latitude": "33.38481",
      "poi_longitude": "-111.9633344",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-565-7072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-cce7-77d8-9fc0-a896f52fb778",
        "storage_key": "property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5Qh3DFoPK4cRatUlkPQdAFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_fe8654d5-c9f7-4ef7-b8ef-d5164a978553",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Slick City Action Park",
      "poi_type": "Entertainment",
      "poi_address": "845 N 54th St, Chandler, AZ 85226, USA",
      "poi_short_description": "Amusement park for all ages featuring mat slides, a ball court and an arcade, as well as a toddler area.",
      "poi_long_description": "People say this amusement park offers a variety of fun slides, a toddler area, and a dodgeball/basketball court. They highlight the clean, well-organized facility, and the energetic, welcoming atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-a7db-734c-813b-d9390afeb145.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-a7db-734c-813b-d9390afeb145",
        "storage_key": "property/5686072616943616/019d01a0-a7db-734c-813b-d9390afeb145.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://slickcity.com/az-chandler",
      "poi_directions_map_url": "https://maps.google.com/?cid=6152966482479605399&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slick-city-action-park",
      "poi_latitude": "33.3165725",
      "poi_longitude": "-111.9665948",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-641-3888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-cce7-77d8-9fc0-a896f52fb778",
        "storage_key": "property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-aMMC5cFK4cRl-YUf2q6Y1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_ab5042d2-a461-4fbd-a170-ea149abdc847",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "idea Museum",
      "poi_type": "Entertainment",
      "poi_address": "150 W Pepper Pl, Mesa, AZ 85201, USA",
      "poi_short_description": "Fine arts museum encouraging self-expression for youngsters through hands-on activities.",
      "poi_long_description": "Fine arts museum encouraging self-expression for youngsters through hands-on activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-a9fb-736d-ab82-a719eac3f4ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-a9fb-736d-ab82-a719eac3f4ac",
        "storage_key": "property/5686072616943616/019d01a0-a9fb-736d-ab82-a719eac3f4ac.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.ideamuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11142221236182862410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "idea-museum",
      "poi_latitude": "33.416723",
      "poi_longitude": "-111.836178",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 480-644-2468",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-cce9-72f9-9072-51f10b0eb95f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-cce9-72f9-9072-51f10b0eb95f",
        "storage_key": "property/5686072616943616/019d01a0-cce9-72f9-9072-51f10b0eb95f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJr5YLDOmnK4cRSkp-Jy4foZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_105a24e8-f541-471a-ac10-e3842242613a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Altitude Trampoline Park Gilbert",
      "poi_type": "Entertainment",
      "poi_address": "701 N Gilbert Rd, Gilbert, AZ 85234, USA",
      "poi_short_description": "Kids-friendly indoor trampoline park with an open floor plan that features dodgeball, foam pits and climbing, as well as parties.",
      "poi_long_description": "People say this amusement park offers a variety of trampolines, interactive games, and a dedicated area for younger children. They highlight the spacious layout, clean facilities, and attentive staff. They also like the fun and safe environment, and the good value for the price of admission.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.altitudetrampolinepark.com/locations/arizona/gilbert/701-n-gilbert-road/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13445158021992475880&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "altitude-trampoline-park-gilbert",
      "poi_latitude": "33.3623341",
      "poi_longitude": "-111.7880621",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 480-534-8684",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-cce7-77d8-9fc0-a896f52fb778",
        "storage_key": "property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGcV0cjipK4cR6OzaSfzLlro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_752881d4-1fee-4273-81e8-8639d1df5c2e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "1616 W Ruby Dr, Tempe, AZ 85284, USA",
      "poi_short_description": "Family-friendly athletic club offering a fitness floor, studio classes, indoor and outdoor pools, plus a spa and kids’ programs.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, classes, and amenities, including tennis courts, a lap pool, and pickleball. They also highlight the clean and bright space, and the knowledgeable and supportive trainers.\n\nOther reviews mention the monthly rates can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-ab45-7316-a7a2-ce9790f1da7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-ab45-7316-a7a2-ce9790f1da7c",
        "storage_key": "property/5686072616943616/019d01a0-ab45-7316-a7a2-ce9790f1da7c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lifetime.life/locations/az/tempe.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=2681829493569576902&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "33.3413432",
      "poi_longitude": "-111.9643591",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-705-8855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-cce7-77d8-9fc0-a896f52fb778",
        "storage_key": "property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB99P-80FK4cRxl9hKLfFNyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d0be9eaa-6d54-47d8-9988-f642c78ec359",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1200 N Alma School Rd, Chandler, AZ 85224, USA",
      "poi_short_description": "Bright athletic club that’s part of a chain offering workout equipment, pools, group classes and personal training.",
      "poi_long_description": "People say this gym offers a wide variety of machines, free weights, and fitness classes, as well as amenities like a sauna, steam room, and massage chairs. They also highlight the friendly, welcoming, and helpful staff, and the clean and well-maintained facilities.\n\nOther reviews mention the cancellation process can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-ae5f-7439-8bcc-9c389a874866.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-ae5f-7439-8bcc-9c389a874866",
        "storage_key": "property/5686072616943616/019d01a0-ae5f-7439-8bcc-9c389a874866.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://vasafitness.com/locations/az/chandler-az/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=2576456338315450084&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "33.32258100000001",
      "poi_longitude": "-111.860333",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 602-603-0814",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-cce7-77d8-9fc0-a896f52fb778",
        "storage_key": "property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoecIIRQHK4cR5JaYmGNpwSM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_81239457-4d5b-4fb9-ba18-6633a5c43f73",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "63 E Southern Ave, Tempe, AZ 85282, USA",
      "poi_short_description": "Clean gym offering classes, weights and cardiovascular equipment.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including a basketball court, pool, and sauna, and the facilities are clean and well-maintained. They also highlight the friendly and helpful staff, and the welcoming and positive atmosphere.\n\nOther reviews mention the gym can be busy during peak hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-af8e-7213-a6f6-cdc83b9d73cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-af8e-7213-a6f6-cdc83b9d73cf",
        "storage_key": "property/5686072616943616/019d01a0-af8e-7213-a6f6-cdc83b9d73cf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=38&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=14282970337445433486&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.3916509",
      "poi_longitude": "-111.9381288",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-829-0622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-cce7-77d8-9fc0-a896f52fb778",
        "storage_key": "property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIdgTFaUIK4cRjlDg9NhNN8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5da9635c-e2c2-4c80-b840-13c69f1bdc09",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Inspire Courts AZ",
      "poi_type": "Health and Wellness",
      "poi_address": "1090 N Fiesta Blvd, Gilbert, AZ 85233, USA",
      "poi_short_description": "Basketball gym offering practice sessions, courts and volleyball tournaments.",
      "poi_long_description": "People say this gym offers a variety of sports events and has a nice atmosphere with large fans.\n\nOther reviews mention the admission and parking fees can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-b006-7048-a5c3-4ec68eed6fd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-b006-7048-a5c3-4ec68eed6fd1",
        "storage_key": "property/5686072616943616/019d01a0-b006-7048-a5c3-4ec68eed6fd1.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.inspirecourtsaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11020540132396082551&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "inspire-courts-az",
      "poi_latitude": "33.3693466",
      "poi_longitude": "-111.8357009",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-221-7218",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-cce7-77d8-9fc0-a896f52fb778",
        "storage_key": "property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-1nFujeoK4cRd6VncNzS8Jg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_67e389ed-575d-4f3e-a3de-9e3c43316c1b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1840 E Warner Rd STE 111, Tempe, AZ 85284, USA",
      "poi_short_description": "Chain fitness center with cardio and weight equipment, group classes, a pool, and kids' club.",
      "poi_long_description": "Some gym goers say this gym offers a wide variety of equipment, classes, and amenities, including a pool, sauna, and helpful, friendly staff.\n\nOther reviews mention the membership fees can be unclear and difficult to cancel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-a9ec-772e-a2eb-7ec7cfac6e8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-a9ec-772e-a2eb-7ec7cfac6e8f",
        "storage_key": "property/5686072616943616/019d01a0-a9ec-772e-a2eb-7ec7cfac6e8f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/tempe/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3806262827972799037&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "33.3356239",
      "poi_longitude": "-111.9095203",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 480-718-5020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-cce7-77d8-9fc0-a896f52fb778",
        "storage_key": "property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7z_v1uIGK4cRPaoXJ-CP0jQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b0233367-f98b-4b6b-b618-213663786d1d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Banner Desert Medical Center | Mesa, AZ | Dobson Rd.",
      "poi_type": "Health and Wellness",
      "poi_address": "1400 S Dobson Rd, Mesa, AZ 85202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-b0ce-7239-9ce3-1fe68e1ba74d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-b0ce-7239-9ce3-1fe68e1ba74d",
        "storage_key": "property/5686072616943616/019d01a0-b0ce-7239-9ce3-1fe68e1ba74d.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/mesa/banner-desert-medical-center?y_source=1_MTE5MDczNDgtNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=614197494924193389&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "banner-desert-medical-center--mesa-az--dobson-rd",
      "poi_latitude": "33.3908762",
      "poi_longitude": "-111.8771772",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 480-412-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-cce5-7065-b8d7-09ca86fd91d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-cce5-7065-b8d7-09ca86fd91d9",
        "storage_key": "property/5686072616943616/019d01a0-cce5-7065-b8d7-09ca86fd91d9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJO1qJLOEHK4cRbS7kEl4Rhgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_4c20128a-0597-4f55-9486-5b143c26da22",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Banner Ocotillo Medical Center | Chandler, AZ | Alma School Rd.",
      "poi_type": "Health and Wellness",
      "poi_address": "1405 S Alma School Rd, Chandler, AZ 85286, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-b2b9-779b-81d1-f30ba384ae67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-b2b9-779b-81d1-f30ba384ae67",
        "storage_key": "property/5686072616943616/019d01a0-b2b9-779b-81d1-f30ba384ae67.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/chandler/banner-ocotillo-medical-center?cid=yext%3Asearch_listing%3Alocations%3Ahospital&y_source=1_MTc5NzY0MjQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11344485889690259296&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "banner-ocotillo-medical-center--chandler-az--alma-school-rd",
      "poi_latitude": "33.2854369",
      "poi_longitude": "-111.8568233",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 480-256-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-cce5-7065-b8d7-09ca86fd91d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-cce5-7065-b8d7-09ca86fd91d9",
        "storage_key": "property/5686072616943616/019d01a0-cce5-7065-b8d7-09ca86fd91d9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJf4rSycYBK4cRYE9rns-1b50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4c8fa1d5-7e41-4f38-8060-7a550f5b9ca0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Desert Breeze Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "660 North Desert Breeze Blvd E, Chandler, AZ 85226, USA",
      "poi_short_description": "This large public park offers a lake, splash pad, sport courts & fields, paths & a playground.",
      "poi_long_description": "People say this park offers a variety of activities, including a train ride, fishing, playgrounds, and a splash pad. They highlight the beautiful lake, scenic walking trails, and shaded picnic areas with grills, as well as the clean facilities and well-maintained grounds. They also like the peaceful and family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-b482-7135-a559-757f698a3c1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-b482-7135-a559-757f698a3c1e",
        "storage_key": "property/5686072616943616/019d01a0-b482-7135-a559-757f698a3c1e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://desertbreezerr.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6836529641264262526&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "desert-breeze-park",
      "poi_latitude": "33.3119719",
      "poi_longitude": "-111.919828",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 480-893-6652",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-ccf9-75c4-a2cc-273762a566b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-ccf9-75c4-a2cc-273762a566b4",
        "storage_key": "property/5686072616943616/019d01a0-ccf9-75c4-a2cc-273762a566b4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJd6eviMUGK4cRfi38u3w74F4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_93713ebc-7642-4fd0-8d53-4d706d6b87b0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Dobson Ranch Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2155 S Dobson Rd, Mesa, AZ 85202, USA",
      "poi_short_description": "Municipal golf center with 18 holes of tree-lined fairways, a lighted driving range & pro shop.",
      "poi_long_description": "People say this golf course offers a beautiful course in excellent condition, a nice driving range, and a fun atmosphere. They highlight the great value, especially for residents, and the friendly, attentive staff. They also like the challenging greens and the ample practice facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-b4b1-7471-82a5-46294985d3dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-b4b1-7471-82a5-46294985d3dc",
        "storage_key": "property/5686072616943616/019d01a0-b4b1-7471-82a5-46294985d3dc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://dobsonranchgolfclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=321594549685786380&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dobson-ranch-golf-course",
      "poi_latitude": "33.3749492",
      "poi_longitude": "-111.8782925",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 480-644-2291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-d047-71e8-ab8a-86f450555d97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-d047-71e8-ab8a-86f450555d97",
        "storage_key": "property/5686072616943616/019d01a0-d047-71e8-ab8a-86f450555d97.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJNywLqJMHK4cRDBe5_4mIdgQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_48ccc9ad-2a76-49f5-99f6-f8f4a8c4b1b5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Kokopelli Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1800 W Guadalupe Rd, Gilbert, AZ 85233, USA",
      "poi_short_description": "Challenging course featuring an array of bunkers and a driving range.",
      "poi_long_description": "People say this golf course offers a challenging layout and the greens are in good shape.\n\nOther reviews mention the fairways can be muddy and the bunkers can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-b4da-72e0-b07e-f4c9f8545352.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-b4da-72e0-b07e-f4c9f8545352",
        "storage_key": "property/5686072616943616/019d01a0-b4da-72e0-b07e-f4c9f8545352.webp",
        "width": 1000,
        "height": 680
      },
      "poi_business_url": "https://www.kokopelligc.com/?utm_source=google&utm_medium=organic&utm_campaign=google_business_profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=231510871321153123&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kokopelli-golf-club",
      "poi_latitude": "33.3662877",
      "poi_longitude": "-111.829435",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-926-3589",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-d047-71e8-ab8a-86f450555d97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-d047-71e8-ab8a-86f450555d97",
        "storage_key": "property/5686072616943616/019d01a0-d047-71e8-ab8a-86f450555d97.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ93n_t0uoK4cRYw69Lul9NgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_8ca53e8b-3e88-4729-b503-5a1c483423d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Kiwanis Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Mill Ave. and, S All America Way, Tempe, AZ 85283, USA",
      "poi_short_description": "Park with a lake & a 54,000-sq.-ft. complex with an indoor wave pool & a 15-court tennis center.",
      "poi_long_description": "People say this park offers a lake, walking paths, playgrounds, sports fields, and picnic areas. They highlight the peaceful and welcoming vibe, and the well-maintained grounds. They also like the opportunities for paddle boating, fishing, and birdwatching.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-b738-722d-ad60-eeca99579cd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-b738-722d-ad60-eeca99579cd0",
        "storage_key": "property/5686072616943616/019d01a0-b738-722d-ad60-eeca99579cd0.webp",
        "width": 979,
        "height": 680
      },
      "poi_business_url": "https://www.tempe.gov/Home/Components/FacilityDirectory/FacilityDirectory/120/3542?npage=2",
      "poi_directions_map_url": "https://maps.google.com/?cid=13961563785378829176&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kiwanis-park",
      "poi_latitude": "33.3718923",
      "poi_longitude": "-111.9391798",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-350-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-ccf9-75c4-a2cc-273762a566b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-ccf9-75c4-a2cc-273762a566b4",
        "storage_key": "property/5686072616943616/019d01a0-ccf9-75c4-a2cc-273762a566b4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJx6LURxAGK4cReJN2kEpwwcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8fe5dbce-7f71-4c52-9352-0350875cbdaa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Ken McDonald Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "800 E Divot Dr, Tempe, AZ 85283, USA",
      "poi_short_description": "18-hole public course with wide fairways, a lighted driving range, a pro shop & a bar & grill.",
      "poi_long_description": "People say this golf course offers challenging greens and a fun layout. They also highlight the course can be in good shape and the staff can be friendly.\n\nSome reviews mention the pace of play can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-b9be-70f1-889e-86b987d88624.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-b9be-70f1-889e-86b987d88624",
        "storage_key": "property/5686072616943616/019d01a0-b9be-70f1-889e-86b987d88624.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.playkenmcdonald.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1877089268074437586&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ken-mcdonald-golf-course",
      "poi_latitude": "33.3571383",
      "poi_longitude": "-111.9326939",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 480-878-3332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-d047-71e8-ab8a-86f450555d97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-d047-71e8-ab8a-86f450555d97",
        "storage_key": "property/5686072616943616/019d01a0-d047-71e8-ab8a-86f450555d97.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJYSU7UG8GK4cR0ltGe77CDBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_34cf9f6c-5ad3-43c0-93c7-893e8532b3e9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Chandler Municipal Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2380 S Stinson Way, Chandler, AZ 85286, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-ba0d-736c-be7c-660bea77a9d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-ba0d-736c-be7c-660bea77a9d0",
        "storage_key": "property/5686072616943616/019d01a0-ba0d-736c-be7c-660bea77a9d0.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://www.chandleraz.gov/business/chandler-municipal-airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=7153949594721350451&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chandler-municipal-airport",
      "poi_latitude": "33.271614",
      "poi_longitude": "-111.8133",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 480-782-3540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-d040-7603-9169-aaca7ba5bbb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-d040-7603-9169-aaca7ba5bbb2",
        "storage_key": "property/5686072616943616/019d01a0-d040-7603-9169-aaca7ba5bbb2.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJs7GftvyqK4cRM3NqzkDvR2M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_3c1eee88-7a6c-498b-a2e9-3b5ec6503450",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Dorsey Ln/Apache Blvd",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tempe, AZ 85281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-ba34-73cf-9b2f-997ad7dc3b57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-ba34-73cf-9b2f-997ad7dc3b57",
        "storage_key": "property/5686072616943616/019d01a0-ba34-73cf-9b2f-997ad7dc3b57.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13215672625481361333&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dorsey-lnapache-blvd",
      "poi_latitude": "33.414769",
      "poi_longitude": "-111.916907",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-cce7-77d8-9fc0-a896f52fb778",
        "storage_key": "property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR3tuBO4IK4cRtaertTuAZ7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_ae3259b2-f2e8-476d-8cff-05e7d134d9dc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Chandler Airport Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "1850 E Northrop Blvd, Chandler, AZ 85286, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-bc99-77b7-85d5-2293d294e3e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-bc99-77b7-85d5-2293d294e3e0",
        "storage_key": "property/5686072616943616/019d01a0-bc99-77b7-85d5-2293d294e3e0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.chandleraz.gov/airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=8857070537003557214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chandler-airport-center",
      "poi_latitude": "33.2796168",
      "poi_longitude": "-111.8069515",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-782-3540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-d040-7603-9169-aaca7ba5bbb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-d040-7603-9169-aaca7ba5bbb2",
        "storage_key": "property/5686072616943616/019d01a0-d040-7603-9169-aaca7ba5bbb2.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJjwi5naqrK4cRXuGsBLqi6no",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_b56e4e0d-52cd-4a25-b935-59b46bacb440",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Price-101/Apache Blvd",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tempe, AZ 85288, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-bfbc-76ba-b224-f780963023bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-bfbc-76ba-b224-f780963023bf",
        "storage_key": "property/5686072616943616/019d01a0-bfbc-76ba-b224-f780963023bf.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11084548879482287968&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "price-101apache-blvd",
      "poi_latitude": "33.41482",
      "poi_longitude": "-111.888099",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-cce7-77d8-9fc0-a896f52fb778",
        "storage_key": "property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjTEXD0IIK4cRYPf-OHo61Jk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_4d05136c-4aac-423a-aced-417f098b62f4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "McClintock/Apache Blvd",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tempe, AZ 85281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-bfa5-73b7-b172-d1c331f8937a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-bfa5-73b7-b172-d1c331f8937a",
        "storage_key": "property/5686072616943616/019d01a0-bfa5-73b7-b172-d1c331f8937a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13252773368337084250&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mcclintockapache-blvd",
      "poi_latitude": "33.4147381",
      "poi_longitude": "-111.9082666",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-cce7-77d8-9fc0-a896f52fb778",
        "storage_key": "property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV59aPvQIK4cRWi99jClP67c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_f7d846da-543e-4ed7-a82a-cad7b297c987",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Intel Ocotillo Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4500 S Dobson Rd, Chandler, AZ 85248, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.intel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9593540309325587613&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intel-ocotillo-campus",
      "poi_latitude": "33.2460842",
      "poi_longitude": "-111.8896449",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 408-765-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-cce7-77d8-9fc0-a896f52fb778",
        "storage_key": "property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx5-tzD8AK4cRnSS-IxUaI4U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e9577b20-2a5a-4a82-b82b-047bf4fd140a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Intel - Chandler Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5000 W Chandler Blvd, Chandler, AZ 85226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.intel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=501564151973696889&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intel---chandler-campus",
      "poi_latitude": "33.3091336",
      "poi_longitude": "-111.9327346",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-820-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-cce7-77d8-9fc0-a896f52fb778",
        "storage_key": "property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGb5SZRqqK4cReVV2VvDp9QY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_786c588f-53e2-492a-9ee8-1097b050d3c6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Intel CH7",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Intel CH7, CH7 N Pvt, Chandler, AZ 85226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-c0df-7159-b20e-d71d26e392f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-c0df-7159-b20e-d71d26e392f1",
        "storage_key": "property/5686072616943616/019d01a0-c0df-7159-b20e-d71d26e392f1.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "http://www.intel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10838182310650502717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intel-ch7",
      "poi_latitude": "33.3109104",
      "poi_longitude": "-111.9324318",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-cce7-77d8-9fc0-a896f52fb778",
        "storage_key": "property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3dZlxLkGK4cRPd4-bWP1aJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ac495479-132d-46e4-8f57-1c237e707bc6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Microchip Technology Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2355 W Chandler Blvd, Chandler, AZ 85224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-c21e-731d-927b-7c8ee7fcf570.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-c21e-731d-927b-7c8ee7fcf570",
        "storage_key": "property/5686072616943616/019d01a0-c21e-731d-927b-7c8ee7fcf570.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.microchip.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16075981335751919628&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "microchip-technology-inc",
      "poi_latitude": "33.3041648",
      "poi_longitude": "-111.8836135",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 480-792-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-cce7-77d8-9fc0-a896f52fb778",
        "storage_key": "property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrQzLeMoAK4cRDIhNxdlbGd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c3796721-11c9-467a-a51f-5d2cdd35d00e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "poi_name": "Wells Fargo & Co. Chandler Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2850 S Price Rd, Chandler, AZ 85286, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-c53d-7256-a45f-8ffd24d3e1f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-c53d-7256-a45f-8ffd24d3e1f7",
        "storage_key": "property/5686072616943616/019d01a0-c53d-7256-a45f-8ffd24d3e1f7.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "http://www.wellsfargo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13512245822728823405&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wells-fargo--co-chandler-campus",
      "poi_latitude": "33.2655934",
      "poi_longitude": "-111.8914146",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-cce7-77d8-9fc0-a896f52fb778",
        "storage_key": "property/5686072616943616/019d01a0-cce7-77d8-9fc0-a896f52fb778.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJafdTm1gAK4cRbeKBHfwjhbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_1fa28a29-0890-4ffa-9d72-3cf4ed196514",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_a3f717f8-6a8a-4965-800f-6d4cbea9815c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_3d3947fa-b1cb-460a-b99f-ba4ebfff83ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_798f4f1f-635e-4e1e-b3c1-555fbc812aab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_1e31c6fc-0fab-4985-9640-53c396144c25",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_4f8fa657-1609-46a7-b0ee-a17f62e5ebc6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_eb51600d-0bb8-4f6f-9731-1004577fb2f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "rating": "5.0",
      "name": "Eowyn Berube",
      "text": "Out of all three apartments we toured today, Dobson left a very strong positive impression on me and my two future roommates. Cindy was incredibly helpful throughout the process—she clearly explained the renting details to us first time renters and made sure we had all the information we needed. Her professionalism and friendliness made the experience feel smooth and reassuring, and it truly set Dobson apart from the other places we visited.\n\nThank you for such a great experience!",
      "date": "2026-01-10",
      "title": ""
    },
    {
      "id": "custom_7bfb681b-39ad-4e46-b5c1-581a68caac5f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "rating": "5.0",
      "name": "Adelaide C. Siena",
      "text": "Robby is one of your best maintenance workers. He does his job exceptionally well. He makes sure that the work orders he receives are completed and runs efficiently. He’s friendly, courteous, and professional. He also leaves the repair area exceptionally tidy. We always look forward to him attending to our work orders. Thanks Robby!!! We greatly appreciate what you do for this residential community.",
      "date": "2025-11-06",
      "title": ""
    },
    {
      "id": "custom_e6657656-a505-449a-a63e-b610bef35e7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "rating": "5.0",
      "name": "Max Slim-Malitpoo",
      "text": "dobson townsend is a great place to be. i feel like i am living in a big big home the apartment is  so spacious. Every time I go to the office with mom I'm so excited to see Cindy and the team because they give me treats and give me lots of fur love. i was the pet of month for september, i've made new friends. I miss my bff koreo my husky neighbor fren, he moved but i made some new friends. thank you cindy for being the best!!!! and robby is the best too, i see him working hard when i am on my walks he keeps the ground and apartments fixed all the time.",
      "date": "2025-10-03",
      "title": ""
    },
    {
      "id": "custom_ad7dbc91-9a76-42ac-b34a-3fc941db91f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "rating": "5.0",
      "name": "Mama Raiderette",
      "text": "There was a recent annual inspection at DTC. During the inspection Robby pointed out that our water heater needed to be replaced. It was leaking and wearing away. The next day, Robby replaced it with a new one. Wow, that was fast and efficient service amidst his busy work schedule. It took a little time to empty the old water heater and detach the necessary parts, then he connected the new one with ease. He completed it with no complaints and as patient as ever. (BTW, we live on the second floor, so he had to transport both heaters up and down) He cleaned up after himself and \"DONE.\" Exceptional work, well done. Also, I would like to mention Olga. I saw her cleaning a vacant apartment's windows. The sparkling shine amazed me, everything was so clean. I had to ask about the products she used. She is also so charming and friendly. We had three vacant apartments in our building, plus the one she was working on, all recently vacated. I saw her every morning on her way to tackle her work for the day to have those apartments ready to rent and she completed all those units, one by one, and eventually all done. I am just astounded how Robby and Olga have so much work to do and they never complain, more importantly, the work gets done. They smile and wave hello and continue about their workday. Also, I would like to mention Cindy in the office. She always takes the time to hear whatever issue that needed to be resolved. She, too, gets to the gist of the matter to settle it. Props to Cindy! Great staff, always willing to do their best to get the job done and make you happy. Thank you, all. Dawn.",
      "date": "2025-10-28",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_f01fd2d0-d678-4cac-ac6c-d9ecf672f01b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d26ee-5456-727d-922c-c85ae086bdfd.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d26ee-5456-727d-922c-c85ae086bdfd",
        "storage_key": "property/5686072616943616/019d26ee-5456-727d-922c-c85ae086bdfd.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Dobson Towne Center | Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=tTVgCKgUpGy"
    },
    {
      "id": "custom_6884bfb3-5f4f-4bb6-8f6e-835a0eb271f0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d26ee-31af-744e-b73f-0c79d78814cd.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d26ee-31af-744e-b73f-0c79d78814cd",
        "storage_key": "property/5686072616943616/019d26ee-31af-744e-b73f-0c79d78814cd.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Dobson Towne Center | 1 BR, 1 BA - 811 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=qvoN4ykyCSP"
    },
    {
      "id": "custom_0d9b6c39-d19b-434f-84f3-f4697cedbccc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d26ee-760e-760e-9b80-2d405b7437a1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d26ee-760e-760e-9b80-2d405b7437a1",
        "storage_key": "property/5686072616943616/019d26ee-760e-760e-9b80-2d405b7437a1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Dobson Towne Center | 2 BR, 2 BA - 1003 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=yJaE7r3Vair"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-0832-756e-9c86-304d2c46322e",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "dobson-towne-centre",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616"
    },
    {
      "lead_collector_id": "0198aa47-0897-72d7-be39-c931856400de",
      "lead_source": "FACEBOOK_ADS",
      "name": "dobson-towne-centre",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616"
    },
    {
      "lead_collector_id": "0198aa47-08f8-712d-bb2a-ea8b4070b625",
      "lead_source": "LANDING_PAGE",
      "name": "dobson-towne-centre",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-chandler-az-dobson-towne-centre",
      "search_query": "pet friendly apartments Chandler AZ",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Chandler, AZ",
      "h2_subtitle": "Explore pet friendly apartments in Chandler, AZ at Dobson Towne Centre. Our community offers spacious living with modern amenities for you and your pet.",
      "page_copy": "Discover the perfect pet friendly apartments Chandler AZ has to offer at Dobson Towne Centre. Located in the heart of North Chandler, our community embraces pet lovers with open arms, ensuring both you and your furry friends feel right at home. Whether you're looking for a one, two, or three-bedroom apartment, our layouts offer the space and comfort you desire.\n\nEnjoy modern amenities such as oak cabinets, a smoke-free environment, and a built-in computer center ideal for remote work. For those needing extra storage or protection, we also have optional detached garages with remote access. At Dobson Towne Centre, we strive to create a welcoming environment not just for you, but for your furry companions too. Schedule a tour today and see why we're the choice for anyone seeking pet friendly living in Chandler, AZ.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-3e85-772f-90ad-02c86befc21b.webp",
      "featured_image_media": {
        "alt_text": "Sparkling outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019d01a0-3e85-772f-90ad-02c86befc21b",
        "storage_key": "property/5686072616943616/019d01a0-3e85-772f-90ad-02c86befc21b.webp",
        "width": 1200,
        "height": 675
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Chandler, AZ",
      "seo_description": "Dobson Towne Centre offers pet friendly apartments in Chandler, AZ. Enjoy spacious units and modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "generator",
      "page_item_url": "smoke-free-apartments-north-chandler-dobson-towne-centre",
      "search_query": "smoke-free apartments North Chandler",
      "category": "Amenity",
      "h1_title": "Smoke-Free Apartments in North Chandler",
      "h2_subtitle": "Discover smoke-free apartments in North Chandler at Dobson Towne Centre. Enjoy a clean, smoke-free lifestyle in a welcoming community.",
      "page_copy": "Welcome to Dobson Towne Centre, where you'll find smoke-free apartments in North Chandler that offer a healthy living environment. Our community is dedicated to providing a clean and comfortable atmosphere for all residents. Choose from a variety of spacious one, two, or three-bedroom floor plans that cater to your lifestyle needs.\n\nBeyond offering smoke-free living, Dobson Towne Centre provides residents with modern amenities such as oak cabinets, a convenient built-in computer center, and optional detached garages with remote access. Located in the vibrant area of North Chandler, its perfect location and smoke-free policy make Dobson Towne Centre a top choice for discerning renters. Explore our community today and see what makes our smoke-free apartments stand out.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-3e85-772f-90ad-02c86befc21b.webp",
      "featured_image_media": {
        "alt_text": "Sparkling outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019d01a0-3e85-772f-90ad-02c86befc21b",
        "storage_key": "property/5686072616943616/019d01a0-3e85-772f-90ad-02c86befc21b.webp",
        "width": 1200,
        "height": 675
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke-Free Apartments in North Chandler",
      "seo_description": "Dobson Towne Centre provides smoke-free apartments in North Chandler with modern amenities and spacious layouts in a healthy living environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "generator",
      "page_item_url": "apartments-with-covered-parking-85224-dobson-towne-centre",
      "search_query": "apartments with covered parking 85224",
      "category": "Amenity",
      "h1_title": "Apartments with Covered Parking in 85224",
      "h2_subtitle": "Find apartments with covered parking in 85224 at Dobson Towne Centre. Secure parking options complement our modern living spaces in Chandler, AZ.",
      "page_copy": "Discover Dobson Towne Centre in Chandler, AZ, offering apartments with covered parking in the 85224 area. Our community provides optional detached garages with remote access, ensuring that your vehicle is safe and protected from the elements. This added convenience allows residents to enjoy peace of mind and easy access whenever needed.\n\nAlongside secure parking, our smoke-free apartments offer a range of modern amenities. Enjoy oak cabinets, a built-in computer center, and spacious floor plans ranging from one to three bedrooms. Perfectly situated in North Chandler, Dobson Towne Centre combines comfort and convenience, making it an ideal home in the bustling area of Chandler, AZ. Explore our availability or schedule a visit today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-3e85-772f-90ad-02c86befc21b.webp",
      "featured_image_media": {
        "alt_text": "Sparkling outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019d01a0-3e85-772f-90ad-02c86befc21b",
        "storage_key": "property/5686072616943616/019d01a0-3e85-772f-90ad-02c86befc21b.webp",
        "width": 1200,
        "height": 675
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Covered Parking in 85224",
      "seo_description": "Dobson Towne Centre offers apartments with covered parking in 85224, Chandler. Enjoy modern amenities and secure parking options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "generator",
      "page_item_url": "apartments-with-roman-soaking-tubs-chandler-dobson-towne-centre",
      "search_query": "apartments with Roman soaking tubs Chandler",
      "category": "Amenity",
      "h1_title": "Apartments with Roman Soaking Tubs in Chandler",
      "h2_subtitle": "Experience luxury living with apartments featuring Roman soaking tubs in Chandler at Dobson Towne Centre, where comfort meets style.",
      "page_copy": "At Dobson Towne Centre, indulge in spacious apartments with Roman soaking tubs in Chandler, providing the perfect retreat for relaxation and luxury living. Our community caters to those who appreciate the finer things in life, offering elegant and comfortable living quarters with each bathtub providing a spa-like atmosphere right in your home.\n\nComplementing these luxurious amenities, we offer additional features such as oak cabinets, a built-in computer center, and optional detached garages with remote access. Located in the vibrant neighborhood of North Chandler, Dobson Towne Centre combines contemporary living with desirable conveniences. Experience ultimate relaxation and discover more about our exceptional apartment offerings by scheduling a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-3e85-772f-90ad-02c86befc21b.webp",
      "featured_image_media": {
        "alt_text": "Sparkling outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019d01a0-3e85-772f-90ad-02c86befc21b",
        "storage_key": "property/5686072616943616/019d01a0-3e85-772f-90ad-02c86befc21b.webp",
        "width": 1200,
        "height": 675
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Roman Soaking Tubs in Chandler",
      "seo_description": "Enjoy luxury apartments with Roman soaking tubs in Chandler at Dobson Towne Centre, providing comfort and style in a desirable location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "generator",
      "page_item_url": "apartments-with-stainless-steel-appliances-north-chandler-dobson-towne-centre",
      "search_query": "apartments with stainless steel appliances North Chandler",
      "category": "Amenity",
      "h1_title": "Apartments with Stainless Steel Appliances",
      "h2_subtitle": "Explore North Chandler's apartments featuring stainless steel appliances at Dobson Towne Centre, delivering modern convenience and style.",
      "page_copy": "Dobson Towne Centre proudly offers stylish apartments with stainless steel appliances in North Chandler, perfect for those who seek modern convenience and sophistication. Our homes are designed with contemporary features and finishes that cater to your culinary needs while elevating the aesthetic of your living space.\n\nIn addition to our modern kitchens, our community amenities include optional detached garages with remote access, oak cabinets, and a built-in computer center to accommodate your lifestyle. Nestled in the heart of North Chandler, Dobson Towne Centre mixes comfort and practicality, making it a premier destination for those looking to upgrade their living experience. Check out our current availability or arrange a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-3e85-772f-90ad-02c86befc21b.webp",
      "featured_image_media": {
        "alt_text": "Sparkling outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019d01a0-3e85-772f-90ad-02c86befc21b",
        "storage_key": "property/5686072616943616/019d01a0-3e85-772f-90ad-02c86befc21b.webp",
        "width": 1200,
        "height": 675
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Stainless Steel Appliances",
      "seo_description": "Find modern apartments with stainless steel appliances in North Chandler at Dobson Towne Centre, offering style and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-chandler-az-dobson-towne-centre",
      "search_query": "1 bedroom apartments chandler az",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Chandler, AZ",
      "h2_subtitle": "Discover contemporary 1 bedroom apartments in Chandler, AZ at Dobson Towne Centre, where comfort meets convenience.",
      "page_copy": "Located in the heart of Chandler, AZ, Dobson Towne Centre offers exquisite 1 bedroom apartments designed for modern living. Ideal for singles or couples, our spacious floor plans provide ample room to relax, complete with oak cabinetry and sophisticated interiors. Enjoy hassle-free living with online payment options and additional features tailored to your lifestyle.\n\nOur community also offers optional detached garages with remote access and a built-in computer center, making Dobson Towne Centre the perfect blend of comfort and convenience. Pet-friendly and smoke-free, our Chandler location provides a refreshing environment for a balanced lifestyle. Visit Dobson Towne Centre today to explore availability and find a home that matches your needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-3e85-772f-90ad-02c86befc21b.webp",
      "featured_image_media": {
        "alt_text": "Sparkling outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019d01a0-3e85-772f-90ad-02c86befc21b",
        "storage_key": "property/5686072616943616/019d01a0-3e85-772f-90ad-02c86befc21b.webp",
        "width": 1200,
        "height": 675
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Chandler, AZ",
      "seo_description": "Explore 1 bedroom apartments in Chandler, AZ at Dobson Towne Centre. Comfort and convenience await in a vibrant neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-north-chandler-dobson-towne-centre",
      "search_query": "2 bedroom apartments in north chandler",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in North Chandler",
      "h2_subtitle": "Find spacious 2 bedroom apartments in North Chandler at Dobson Towne Centre, perfect for modern family living.",
      "page_copy": "Dobson Towne Centre offers stylish 2 bedroom apartments in North Chandler, designed to provide ample space and comfort for families and roommates alike. Our well-appointed homes feature thoughtful layouts, oak cabinets, and modern amenities that cater to contemporary living. Pets are welcome, making our community a great choice for animal lovers.\n\nSituated in vibrant North Chandler, Dobson Towne Centre provides easy access to local dining, shopping, and entertainment options. Enjoy added conveniences like optional detached garages with remote access and a built-in computer center with internet hookup. Explore our diverse community amenities and find your perfect home today by scheduling a tour or checking our availability online.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-3e85-772f-90ad-02c86befc21b.webp",
      "featured_image_media": {
        "alt_text": "Sparkling outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019d01a0-3e85-772f-90ad-02c86befc21b",
        "storage_key": "property/5686072616943616/019d01a0-3e85-772f-90ad-02c86befc21b.webp",
        "width": 1200,
        "height": 675
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in North Chandler",
      "seo_description": "Discover 2 bedroom apartments in North Chandler at Dobson Towne Centre. Ideal for families, with modern amenities and pet-friendly options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5686072616943616",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-near-85224-dobson-towne-centre",
      "search_query": "3 bedroom apartments near 85224",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near 85224",
      "h2_subtitle": "Explore spacious 3 bedroom apartments near 85224 at Dobson Towne Centre, designed for comfortable family living.",
      "page_copy": "Discover the perfect home at Dobson Towne Centre with our spacious 3 bedroom apartments located near the 85224 area. These thoughtfully designed homes are ideal for accommodating families or those who appreciate extra space. Enjoy the convenience of modern amenities, including oak cabinets and built-in computer centers, enhancing your living experience.\n\nNestled in North Chandler, Dobson Towne Centre offers a pet-friendly environment, ensuring members of your family feel right at home. With optional detached garages and smoke-free community amenities, residents can experience both comfort and practicality. Visit us today to explore our current availability and find your ideal three-bedroom apartment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5686072616943616/019d01a0-3e85-772f-90ad-02c86befc21b.webp",
      "featured_image_media": {
        "alt_text": "Sparkling outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019d01a0-3e85-772f-90ad-02c86befc21b",
        "storage_key": "property/5686072616943616/019d01a0-3e85-772f-90ad-02c86befc21b.webp",
        "width": 1200,
        "height": 675
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near 85224",
      "seo_description": "Find spacious 3 bedroom apartments near 85224 at Dobson Towne Centre, offering modern amenities and comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4728"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9147445796"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4805656462"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TH3W439M"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 4"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "5ee4a6c3-cabd-4f38-a183-81671648f664"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Oasis"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/e9b4ecf4-a45e-46a8-9d12-327d8b878849/app.js?property=e9b4ecf4-a45e-46a8-9d12-327d8b878849&propertyName=Dobson+Towne+Centre&channelUuid=c2490af0-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImlOOVhQd3BsN2VyVndIRitxSnpyT0E9PSIsInZhbHVlIjoib2hFNS9MOUkvTVNsTTJVZzRiQ1h0Zz09IiwibWFjIjoiYTRlODc4OTE0NjhlYTQ5YWQxMGU1NWM4ODE0MDQ3MjQxZjY3ZDIxYmVhYzAzNjM0ODhhYWU3MjVlN2U1Zjg0OSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "4728",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "9147445796",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4805656462",
  "custom_google_gtm_id": "GTM-TH3W439M",
  "custom_rollout_phase": "Phase 4",
  "custom_rentgrata_token": "5ee4a6c3-cabd-4f38-a183-81671648f664",
  "custom_vibesites_theme": "Oasis",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/e9b4ecf4-a45e-46a8-9d12-327d8b878849/app.js?property=e9b4ecf4-a45e-46a8-9d12-327d8b878849&propertyName=Dobson+Towne+Centre&channelUuid=c2490af0-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImlOOVhQd3BsN2VyVndIRitxSnpyT0E9PSIsInZhbHVlIjoib2hFNS9MOUkvTVNsTTJVZzRiQ1h0Zz09IiwibWFjIjoiYTRlODc4OTE0NjhlYTQ5YWQxMGU1NWM4ODE0MDQ3MjQxZjY3ZDIxYmVhYzAzNjM0ODhhYWU3MjVlN2U1Zjg0OSJ9",
  "custom_audioeye_site_id": "bb11c360-0bf5-4dd8-a6db-eb46cf1bb57b",
  "custom_audioeye_site_hash": "df5bbdfbbc7d033d5e1ded442bc2d3a4"
};

export const generatedAt = '2026-10-27T17:09:28.759Z';
